// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe, enumOf, taggedUnionOf, is, arrayOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

import type { AccessibilityTestCategory, AccessibilityTestImpact, GetAccessibilityResultsResult } from "./types";

const isCategory = enumOf<AccessibilityTestCategory>("PERCEIVABLE", "OPERABLE", "UNDERSTANDABLE", "ROBUST");

const isImpact = enumOf<AccessibilityTestImpact>("minor", "moderate", "serious", "critical");

const isPassResult = objectOf({
  test_status: is("PASS"),
  rule: string,
  rule_id: maybe(string, true),
  description: string,
  category: isCategory,
});

const isFailureResult = objectOf({
  test_status: is("FAIL"),
  rule: string,
  rule_id: maybe(string, true),
  description: string,
  category: isCategory,
  impact: isImpact,
  needs_review: maybe(boolean),
  snippet: string,
  corrections: objectOf({
    type: enumOf("any", "all"),
    details: arrayOf(string),
  }),
});

export const isGetAccessibilityResultsResult = objectOf<GetAccessibilityResultsResult>({
  status: enumOf<GetAccessibilityResultsResult["status"]>("COMPLETED", "PROCESSING"),
  result: arrayOf(
    taggedUnionOf("test_status", {
      PASS: isPassResult,
      FAIL: isFailureResult,
    })
  ),
});
